import { render, staticRenderFns } from "./HistoryConfigChanges.vue?vue&type=template&id=778a21fe&scoped=true"
import script from "./HistoryConfigChanges.vue?vue&type=script&lang=js"
export * from "./HistoryConfigChanges.vue?vue&type=script&lang=js"
import style0 from "./HistoryConfigChanges.vue?vue&type=style&index=0&id=778a21fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a21fe",
  null
  
)

export default component.exports